export const getTakenCourses = state => state.courses.takenCourses;

export const getTakenCoursesProcessing = state =>
  state.courses.takenCoursesProcessing;

export const getCourseResourcesSaveForLaterProcessing = state =>
  state.courses.courseResourcesSaveForLaterProcessingList;
